import * as React from "react";
import { createRoot } from "react-dom/client";
import { BookingRequest } from "./BookingRequest";

function loadDocument()
{
    let items = document.querySelectorAll("[booking-request]");
    for (let i = 0; i < items.length; i++)
    {
        const item = items[i] as HTMLElement;
        if (!item.dataset.contactDetails) {
            continue;
        }

        const franchiseId = item.dataset.franchiseId ? parseInt(item.dataset.franchiseId) : null;
        const abandonedData = item.dataset.abandoned ? JSON.parse(item.dataset.abandoned) : null;

        const contactDetails = JSON.parse(item.dataset.contactDetails) as FranchiseContactDetails;
        const root = createRoot(item);
        root.render(React.createElement(BookingRequest, { contact_details: contactDetails, franchise_id: franchiseId, abandoned_data: abandonedData }))
    }
}
document.addEventListener("DOMContentLoaded", loadDocument);